import { BODY_SM_SM_STYLES } from '@constants/text.ts';
import { Input } from 'antd';
import type { TextAreaProps } from 'antd/es/input';
import styled from 'styled-components';

const TEXT_STYLES = `
    color: #667185;
    ${BODY_SM_SM_STYLES};
`;

export const StyledTextArea = styled((props: TextAreaProps) => <Input.TextArea {...props} />)`
    & .ant-input {
        padding: 14px 16px;
        border-radius: 8px;
        border: 1px solid var(--CoolGray-30, #c1c7cd);
        ${TEXT_STYLES};
    }

    & .ant-input::placeholder {
        ${TEXT_STYLES};
    }

    & .ant-input-data-count {
        color: var(--colors-text-body, #50566e);
        ${BODY_SM_SM_STYLES};
    }
`;
